<template>
	<table v-bind="$attrs" class="c-list-component">
		<template v-for="row in rows">
			<list-row ref="listRow" :row="row"></list-row>
		</template>
	</table>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import ListRow from '@/components/vue-components/list-row/ListRow.vue';
export default {
    name: 'ListComponent',
	components: { ListRow, VueInput },
    props: {
		rows: {
			type: Array,
			default: () => []
		},
	}
}
</script>